import {
  Companion_getInstancex3rnna8pnr6f as Companion_getInstance,
  LineItem2rt64afaiyloc as LineItem,
} from './databaseModels.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
  properties1qnxlk10mmfrs as properties,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  _MonetaryValue___init__impl__jsc11x21b8u6q6nd7yd as _MonetaryValue___init__impl__jsc11x,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  ChangeRequestInfo190hcn8381h6v as ChangeRequestInfo,
  Issue1fn0d1tovjb9y as Issue,
  AccessInfoj60d6hx1qs8r as AccessInfo,
} from './supportModels.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  LineItemState_NotStarted_getInstance3brd4lyoananz as LineItemState_NotStarted_getInstance,
  LineItemStatehvsx7uvvfwcx as LineItemState,
} from './enums.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_scopeSet(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItem_scopeSet_getInstance());
}
function get_state(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItem_state_getInstance());
}
function get__id(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItem__id_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItem_project_getInstance());
}
function LineItem_name$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function LineItem_name$_get_name_$ref_jmjiog() {
  return (p0) => p0.i20();
}
function LineItem_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_name$_get_serializer_$ref_nvw6y1() {
  return (p0) => p0.h2j();
}
function LineItem_name$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function LineItem_name$_get_annotations_$ref_e1wd17() {
  return (p0) => p0.bz();
}
var LineItem_nameClass;
function LineItem_name() {
  if (LineItem_nameClass === VOID) {
    class $ {
      constructor() {
        LineItem_name_instance = this;
        var tmp = this;
        tmp.y6j_1 = lazy(LineItem_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z6j_1 = lazy(LineItem_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a6k_1 = lazy(LineItem_name$annotations$delegate$lambda);
        this.b6k_1 = '';
        this.c6k_1 = '""';
      }
      i20() {
        var tmp0 = this.y6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_name$_get_name_$ref_jmjiog(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.j6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      f6l(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.f6l(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z6j_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_name$_get_serializer_$ref_nvw6y1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a6k_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_name$_get_annotations_$ref_e1wd17(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_name', VOID, VOID, [SerializableProperty()]);
    LineItem_nameClass = $;
  }
  return LineItem_nameClass;
}
var LineItem_name_instance;
function LineItem_name_getInstance() {
  if (LineItem_name_instance === VOID)
    new (LineItem_name())();
  return LineItem_name_instance;
}
function LineItem_originalPrice$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function LineItem_originalPrice$_get_name_$ref_ifq9cd() {
  return (p0) => p0.i20();
}
function LineItem_originalPrice$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_originalPrice$_get_serializer_$ref_sus6vg() {
  return (p0) => p0.h2j();
}
function LineItem_originalPrice$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function LineItem_originalPrice$_get_annotations_$ref_q186uw() {
  return (p0) => p0.bz();
}
var LineItem_originalPriceClass;
function LineItem_originalPrice() {
  if (LineItem_originalPriceClass === VOID) {
    class $ {
      constructor() {
        LineItem_originalPrice_instance = this;
        var tmp = this;
        tmp.h6l_1 = lazy(LineItem_originalPrice$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i6l_1 = lazy(LineItem_originalPrice$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j6l_1 = lazy(LineItem_originalPrice$annotations$delegate$lambda);
        this.k6l_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.l6l_1 = 'MonetaryValue(0L)';
      }
      i20() {
        var tmp0 = this.h6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_originalPrice$_get_name_$ref_ifq9cd(), null);
        return tmp0.f2();
      }
      m6l(receiver) {
        return receiver.l6k_1;
      }
      k2j(receiver) {
        return new (MonetaryValue())(this.m6l(receiver instanceof LineItem() ? receiver : THROW_CCE()));
      }
      n6l(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.n6l(tmp, value instanceof MonetaryValue() ? value.y5r_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_originalPrice$_get_serializer_$ref_sus6vg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_originalPrice$_get_annotations_$ref_q186uw(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_originalPrice', VOID, VOID, [SerializableProperty()]);
    LineItem_originalPriceClass = $;
  }
  return LineItem_originalPriceClass;
}
var LineItem_originalPrice_instance;
function LineItem_originalPrice_getInstance() {
  if (LineItem_originalPrice_instance === VOID)
    new (LineItem_originalPrice())();
  return LineItem_originalPrice_instance;
}
function LineItem_description$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function LineItem_description$_get_name_$ref_4bwjf5() {
  return (p0) => p0.i20();
}
function LineItem_description$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_description$_get_serializer_$ref_d9fxvs() {
  return (p0) => p0.h2j();
}
function LineItem_description$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function LineItem_description$_get_annotations_$ref_v5n804() {
  return (p0) => p0.bz();
}
var LineItem_descriptionClass;
function LineItem_description() {
  if (LineItem_descriptionClass === VOID) {
    class $ {
      constructor() {
        LineItem_description_instance = this;
        var tmp = this;
        tmp.o6l_1 = lazy(LineItem_description$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p6l_1 = lazy(LineItem_description$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q6l_1 = lazy(LineItem_description$annotations$delegate$lambda);
        this.r6l_1 = '';
        this.s6l_1 = '""';
      }
      i20() {
        var tmp0 = this.o6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_description$_get_name_$ref_4bwjf5(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.k6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      f6l(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.f6l(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.p6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_description$_get_serializer_$ref_d9fxvs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_description$_get_annotations_$ref_v5n804(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_description', VOID, VOID, [SerializableProperty()]);
    LineItem_descriptionClass = $;
  }
  return LineItem_descriptionClass;
}
var LineItem_description_instance;
function LineItem_description_getInstance() {
  if (LineItem_description_instance === VOID)
    new (LineItem_description())();
  return LineItem_description_instance;
}
function LineItem_files$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function LineItem_files$_get_name_$ref_yyj7x0() {
  return (p0) => p0.i20();
}
function LineItem_files$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_files$_get_serializer_$ref_srfpsj() {
  return (p0) => p0.h2j();
}
function LineItem_files$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function LineItem_files$_get_annotations_$ref_fo8flj() {
  return (p0) => p0.bz();
}
var LineItem_filesClass;
function LineItem_files() {
  if (LineItem_filesClass === VOID) {
    class $ {
      constructor() {
        LineItem_files_instance = this;
        var tmp = this;
        tmp.t6l_1 = lazy(LineItem_files$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u6l_1 = lazy(LineItem_files$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v6l_1 = lazy(LineItem_files$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp_2.w6l_1 = emptyList();
        this.x6l_1 = 'listOf()';
      }
      i20() {
        var tmp0 = this.t6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_files$_get_name_$ref_yyj7x0(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.n6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      y6l(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.y6l(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.u6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_files$_get_serializer_$ref_srfpsj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_files$_get_annotations_$ref_fo8flj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_files', VOID, VOID, [SerializableProperty()]);
    LineItem_filesClass = $;
  }
  return LineItem_filesClass;
}
var LineItem_files_instance;
function LineItem_files_getInstance() {
  if (LineItem_files_instance === VOID)
    new (LineItem_files())();
  return LineItem_files_instance;
}
function LineItem_order$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function LineItem_order$_get_name_$ref_b82uw3() {
  return (p0) => p0.i20();
}
function LineItem_order$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_order$_get_serializer_$ref_6mnv7u() {
  return (p0) => p0.h2j();
}
function LineItem_order$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function LineItem_order$_get_annotations_$ref_8iwsc2() {
  return (p0) => p0.bz();
}
var LineItem_orderClass;
function LineItem_order() {
  if (LineItem_orderClass === VOID) {
    class $ {
      constructor() {
        LineItem_order_instance = this;
        var tmp = this;
        tmp.z6l_1 = lazy(LineItem_order$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a6m_1 = lazy(LineItem_order$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b6m_1 = lazy(LineItem_order$annotations$delegate$lambda);
        this.c6m_1 = 0.5;
        this.d6m_1 = '0.5';
      }
      i20() {
        var tmp0 = this.z6l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_order$_get_name_$ref_b82uw3(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.m6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      e6m(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.e6m(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_order$_get_serializer_$ref_6mnv7u(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_order$_get_annotations_$ref_8iwsc2(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_order', VOID, VOID, [SerializableProperty()]);
    LineItem_orderClass = $;
  }
  return LineItem_orderClass;
}
var LineItem_order_instance;
function LineItem_order_getInstance() {
  if (LineItem_order_instance === VOID)
    new (LineItem_order())();
  return LineItem_order_instance;
}
function get_order(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItem_order_getInstance());
}
function get_started(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItem_started_getInstance());
}
function get_cancelled(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItem_cancelled_getInstance());
}
function get_created(_this__u8e3s4) {
  return _this__u8e3s4.prop(LineItem_created_getInstance());
}
function prepareLineItemFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [LineItem__id_getInstance(), LineItem_project_getInstance(), LineItem_changeRequest_getInstance(), LineItem_scopeView_getInstance(), LineItem_scopeSet_getInstance(), LineItem_name_getInstance(), LineItem_description_getInstance(), LineItem_originalPrice_getInstance(), LineItem_order_getInstance(), LineItem_files_getInstance(), LineItem_started_getInstance(), LineItem_state_getInstance(), LineItem_acceptedPriceChange_getInstance(), LineItem_allowRaiseIssue_getInstance(), LineItem_allowFileDispute_getInstance(), LineItem_allowLockProject_getInstance(), LineItem_issue_getInstance(), LineItem_credits_getInstance(), LineItem_complete_getInstance(), LineItem_ledgerItems_getInstance(), LineItem_cancelled_getInstance(), LineItem_created_getInstance(), LineItem_contractorDeposits_getInstance(), LineItem_readBy_getInstance(), LineItem_lastModifiedBy_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function LineItem_scopeSet$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function LineItem_scopeSet$_get_name_$ref_6gca31() {
  return (p0) => p0.i20();
}
function LineItem_scopeSet$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_scopeSet$_get_serializer_$ref_6ocx7q() {
  return (p0) => p0.h2j();
}
function LineItem_scopeSet$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function LineItem_scopeSet$_get_annotations_$ref_m7wmsi() {
  return (p0) => p0.bz();
}
var LineItem_scopeSetClass;
function LineItem_scopeSet() {
  if (LineItem_scopeSetClass === VOID) {
    class $ {
      constructor() {
        LineItem_scopeSet_instance = this;
        var tmp = this;
        tmp.f6m_1 = lazy(LineItem_scopeSet$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g6m_1 = lazy(LineItem_scopeSet$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h6m_1 = lazy(LineItem_scopeSet$annotations$delegate$lambda);
        this.i6m_1 = null;
        this.j6m_1 = 'null';
      }
      i20() {
        var tmp0 = this.f6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_scopeSet$_get_name_$ref_6gca31(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.i6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      k6m(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.k6m(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_scopeSet$_get_serializer_$ref_6ocx7q(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_scopeSet$_get_annotations_$ref_m7wmsi(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_scopeSet', VOID, VOID, [SerializableProperty()]);
    LineItem_scopeSetClass = $;
  }
  return LineItem_scopeSetClass;
}
var LineItem_scopeSet_instance;
function LineItem_scopeSet_getInstance() {
  if (LineItem_scopeSet_instance === VOID)
    new (LineItem_scopeSet())();
  return LineItem_scopeSet_instance;
}
function LineItem_state$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(11);
}
function LineItem_state$_get_name_$ref_2kbkai() {
  return (p0) => p0.i20();
}
function LineItem_state$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_state$_get_serializer_$ref_xavmel() {
  return (p0) => p0.h2j();
}
function LineItem_state$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(11);
}
function LineItem_state$_get_annotations_$ref_gzrgk1() {
  return (p0) => p0.bz();
}
var LineItem_stateClass;
function LineItem_state() {
  if (LineItem_stateClass === VOID) {
    class $ {
      constructor() {
        LineItem_state_instance = this;
        var tmp = this;
        tmp.l6m_1 = lazy(LineItem_state$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m6m_1 = lazy(LineItem_state$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n6m_1 = lazy(LineItem_state$annotations$delegate$lambda);
        this.o6m_1 = LineItemState_NotStarted_getInstance();
        this.p6m_1 = 'LineItemState.NotStarted';
      }
      i20() {
        var tmp0 = this.l6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_state$_get_name_$ref_2kbkai(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.p6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      q6m(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.q6m(tmp, value instanceof LineItemState() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_state$_get_serializer_$ref_xavmel(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_state$_get_annotations_$ref_gzrgk1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_state', VOID, VOID, [SerializableProperty()]);
    LineItem_stateClass = $;
  }
  return LineItem_stateClass;
}
var LineItem_state_instance;
function LineItem_state_getInstance() {
  if (LineItem_state_instance === VOID)
    new (LineItem_state())();
  return LineItem_state_instance;
}
function LineItem__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function LineItem__id$_get_name_$ref_um89pt() {
  return (p0) => p0.i20();
}
function LineItem__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem__id$_get_serializer_$ref_brdbnu() {
  return (p0) => p0.h2j();
}
function LineItem__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function LineItem__id$_get_annotations_$ref_6osava() {
  return (p0) => p0.bz();
}
var LineItem__idClass;
function LineItem__id() {
  if (LineItem__idClass === VOID) {
    class $ {
      constructor() {
        LineItem__id_instance = this;
        var tmp = this;
        tmp.r6m_1 = lazy(LineItem__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s6m_1 = lazy(LineItem__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t6m_1 = lazy(LineItem__id$annotations$delegate$lambda);
        this.u6m_1 = Companion_getInstance_0().k2p();
        this.v6m_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.r6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem__id$_get_name_$ref_um89pt(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.e6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      w6m(receiver, value) {
        return receiver.g6l(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.w6m(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem__id$_get_serializer_$ref_brdbnu(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem__id$_get_annotations_$ref_6osava(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem__id', VOID, VOID, [SerializableProperty()]);
    LineItem__idClass = $;
  }
  return LineItem__idClass;
}
var LineItem__id_instance;
function LineItem__id_getInstance() {
  if (LineItem__id_instance === VOID)
    new (LineItem__id())();
  return LineItem__id_instance;
}
function LineItem_project$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function LineItem_project$_get_name_$ref_m861ou() {
  return (p0) => p0.i20();
}
function LineItem_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_project$_get_serializer_$ref_r41xo5() {
  return (p0) => p0.h2j();
}
function LineItem_project$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function LineItem_project$_get_annotations_$ref_480elj() {
  return (p0) => p0.bz();
}
var LineItem_projectClass;
function LineItem_project() {
  if (LineItem_projectClass === VOID) {
    class $ {
      constructor() {
        LineItem_project_instance = this;
        var tmp = this;
        tmp.x6m_1 = lazy(LineItem_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y6m_1 = lazy(LineItem_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z6m_1 = lazy(LineItem_project$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.x6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_project$_get_name_$ref_m861ou(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.f6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      w6m(receiver, value) {
        return receiver.g6l(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.w6m(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_project$_get_serializer_$ref_r41xo5(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z6m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_project$_get_annotations_$ref_480elj(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_project', VOID, VOID, [SerializableProperty()]);
    LineItem_projectClass = $;
  }
  return LineItem_projectClass;
}
var LineItem_project_instance;
function LineItem_project_getInstance() {
  if (LineItem_project_instance === VOID)
    new (LineItem_project())();
  return LineItem_project_instance;
}
function LineItem_started$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(10);
}
function LineItem_started$_get_name_$ref_c6dklm() {
  return (p0) => p0.i20();
}
function LineItem_started$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_started$_get_serializer_$ref_a8gj6l() {
  return (p0) => p0.h2j();
}
function LineItem_started$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(10);
}
function LineItem_started$_get_annotations_$ref_lrmoox() {
  return (p0) => p0.bz();
}
var LineItem_startedClass;
function LineItem_started() {
  if (LineItem_startedClass === VOID) {
    class $ {
      constructor() {
        LineItem_started_instance = this;
        var tmp = this;
        tmp.a6n_1 = lazy(LineItem_started$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b6n_1 = lazy(LineItem_started$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c6n_1 = lazy(LineItem_started$annotations$delegate$lambda);
        this.d6n_1 = null;
        this.e6n_1 = 'null';
      }
      i20() {
        var tmp0 = this.a6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_started$_get_name_$ref_c6dklm(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.o6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      f6n(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.f6n(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.b6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_started$_get_serializer_$ref_a8gj6l(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_started$_get_annotations_$ref_lrmoox(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_started', VOID, VOID, [SerializableProperty()]);
    LineItem_startedClass = $;
  }
  return LineItem_startedClass;
}
var LineItem_started_instance;
function LineItem_started_getInstance() {
  if (LineItem_started_instance === VOID)
    new (LineItem_started())();
  return LineItem_started_instance;
}
function LineItem_cancelled$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(20);
}
function LineItem_cancelled$_get_name_$ref_oeouka() {
  return (p0) => p0.i20();
}
function LineItem_cancelled$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[20];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_cancelled$_get_serializer_$ref_ouo3kj() {
  return (p0) => p0.h2j();
}
function LineItem_cancelled$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(20);
}
function LineItem_cancelled$_get_annotations_$ref_r16lkf() {
  return (p0) => p0.bz();
}
var LineItem_cancelledClass;
function LineItem_cancelled() {
  if (LineItem_cancelledClass === VOID) {
    class $ {
      constructor() {
        LineItem_cancelled_instance = this;
        var tmp = this;
        tmp.g6n_1 = lazy(LineItem_cancelled$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h6n_1 = lazy(LineItem_cancelled$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i6n_1 = lazy(LineItem_cancelled$annotations$delegate$lambda);
        this.j6n_1 = null;
        this.k6n_1 = 'null';
      }
      i20() {
        var tmp0 = this.g6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_cancelled$_get_name_$ref_oeouka(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.y6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      f6n(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.f6n(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_cancelled$_get_serializer_$ref_ouo3kj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_cancelled$_get_annotations_$ref_r16lkf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_cancelled', VOID, VOID, [SerializableProperty()]);
    LineItem_cancelledClass = $;
  }
  return LineItem_cancelledClass;
}
var LineItem_cancelled_instance;
function LineItem_cancelled_getInstance() {
  if (LineItem_cancelled_instance === VOID)
    new (LineItem_cancelled())();
  return LineItem_cancelled_instance;
}
function LineItem_created$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(21);
}
function LineItem_created$_get_name_$ref_qhft19() {
  return (p0) => p0.i20();
}
function LineItem_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[21];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_created$_get_serializer_$ref_ruu4o4() {
  return (p0) => p0.h2j();
}
function LineItem_created$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(21);
}
function LineItem_created$_get_annotations_$ref_raafko() {
  return (p0) => p0.bz();
}
var LineItem_createdClass;
function LineItem_created() {
  if (LineItem_createdClass === VOID) {
    class $ {
      constructor() {
        LineItem_created_instance = this;
        var tmp = this;
        tmp.l6n_1 = lazy(LineItem_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m6n_1 = lazy(LineItem_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n6n_1 = lazy(LineItem_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.o6n_1 = get_default(Companion_instance).b1m();
        this.p6n_1 = 'now()';
      }
      i20() {
        var tmp0 = this.l6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_created$_get_name_$ref_qhft19(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.z6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      q6n(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.q6n(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_created$_get_serializer_$ref_ruu4o4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_created$_get_annotations_$ref_raafko(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_created', VOID, VOID, [SerializableProperty()]);
    LineItem_createdClass = $;
  }
  return LineItem_createdClass;
}
var LineItem_created_instance;
function LineItem_created_getInstance() {
  if (LineItem_created_instance === VOID)
    new (LineItem_created())();
  return LineItem_created_instance;
}
function LineItem_changeRequest$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function LineItem_changeRequest$_get_name_$ref_tzmsng() {
  return (p0) => p0.i20();
}
function LineItem_changeRequest$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_changeRequest$_get_serializer_$ref_cfk4md() {
  return (p0) => p0.h2j();
}
function LineItem_changeRequest$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function LineItem_changeRequest$_get_annotations_$ref_e52mv3() {
  return (p0) => p0.bz();
}
var LineItem_changeRequestClass;
function LineItem_changeRequest() {
  if (LineItem_changeRequestClass === VOID) {
    class $ {
      constructor() {
        LineItem_changeRequest_instance = this;
        var tmp = this;
        tmp.r6n_1 = lazy(LineItem_changeRequest$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s6n_1 = lazy(LineItem_changeRequest$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t6n_1 = lazy(LineItem_changeRequest$annotations$delegate$lambda);
        this.u6n_1 = null;
        this.v6n_1 = 'null';
      }
      i20() {
        var tmp0 = this.r6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_changeRequest$_get_name_$ref_tzmsng(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.g6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      w6n(receiver, value) {
        return receiver.g6l(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.w6n(tmp, (value == null ? true : value instanceof ChangeRequestInfo()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_changeRequest$_get_serializer_$ref_cfk4md(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_changeRequest$_get_annotations_$ref_e52mv3(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_changeRequest', VOID, VOID, [SerializableProperty()]);
    LineItem_changeRequestClass = $;
  }
  return LineItem_changeRequestClass;
}
var LineItem_changeRequest_instance;
function LineItem_changeRequest_getInstance() {
  if (LineItem_changeRequest_instance === VOID)
    new (LineItem_changeRequest())();
  return LineItem_changeRequest_instance;
}
function LineItem_scopeView$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function LineItem_scopeView$_get_name_$ref_s8ogzy() {
  return (p0) => p0.i20();
}
function LineItem_scopeView$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_scopeView$_get_serializer_$ref_gu1qa3() {
  return (p0) => p0.h2j();
}
function LineItem_scopeView$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function LineItem_scopeView$_get_annotations_$ref_8k06c9() {
  return (p0) => p0.bz();
}
var LineItem_scopeViewClass;
function LineItem_scopeView() {
  if (LineItem_scopeViewClass === VOID) {
    class $ {
      constructor() {
        LineItem_scopeView_instance = this;
        var tmp = this;
        tmp.x6n_1 = lazy(LineItem_scopeView$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y6n_1 = lazy(LineItem_scopeView$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z6n_1 = lazy(LineItem_scopeView$annotations$delegate$lambda);
        this.a6o_1 = null;
        this.b6o_1 = 'null';
      }
      i20() {
        var tmp0 = this.x6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_scopeView$_get_name_$ref_s8ogzy(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.h6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      k6m(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.k6m(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_scopeView$_get_serializer_$ref_gu1qa3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z6n_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_scopeView$_get_annotations_$ref_8k06c9(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_scopeView', VOID, VOID, [SerializableProperty()]);
    LineItem_scopeViewClass = $;
  }
  return LineItem_scopeViewClass;
}
var LineItem_scopeView_instance;
function LineItem_scopeView_getInstance() {
  if (LineItem_scopeView_instance === VOID)
    new (LineItem_scopeView())();
  return LineItem_scopeView_instance;
}
function LineItem_acceptedPriceChange$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(12);
}
function LineItem_acceptedPriceChange$_get_name_$ref_3s4evb() {
  return (p0) => p0.i20();
}
function LineItem_acceptedPriceChange$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_acceptedPriceChange$_get_serializer_$ref_lw4moi() {
  return (p0) => p0.h2j();
}
function LineItem_acceptedPriceChange$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(12);
}
function LineItem_acceptedPriceChange$_get_annotations_$ref_na9ysy() {
  return (p0) => p0.bz();
}
var LineItem_acceptedPriceChangeClass;
function LineItem_acceptedPriceChange() {
  if (LineItem_acceptedPriceChangeClass === VOID) {
    class $ {
      constructor() {
        LineItem_acceptedPriceChange_instance = this;
        var tmp = this;
        tmp.c6o_1 = lazy(LineItem_acceptedPriceChange$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d6o_1 = lazy(LineItem_acceptedPriceChange$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e6o_1 = lazy(LineItem_acceptedPriceChange$annotations$delegate$lambda);
        this.f6o_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.g6o_1 = 'MonetaryValue(0L)';
      }
      i20() {
        var tmp0 = this.c6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_acceptedPriceChange$_get_name_$ref_3s4evb(), null);
        return tmp0.f2();
      }
      m6l(receiver) {
        return receiver.q6k_1;
      }
      k2j(receiver) {
        return new (MonetaryValue())(this.m6l(receiver instanceof LineItem() ? receiver : THROW_CCE()));
      }
      n6l(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.n6l(tmp, value instanceof MonetaryValue() ? value.y5r_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_acceptedPriceChange$_get_serializer_$ref_lw4moi(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_acceptedPriceChange$_get_annotations_$ref_na9ysy(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_acceptedPriceChange', VOID, VOID, [SerializableProperty()]);
    LineItem_acceptedPriceChangeClass = $;
  }
  return LineItem_acceptedPriceChangeClass;
}
var LineItem_acceptedPriceChange_instance;
function LineItem_acceptedPriceChange_getInstance() {
  if (LineItem_acceptedPriceChange_instance === VOID)
    new (LineItem_acceptedPriceChange())();
  return LineItem_acceptedPriceChange_instance;
}
function LineItem_allowRaiseIssue$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(13);
}
function LineItem_allowRaiseIssue$_get_name_$ref_by02yz() {
  return (p0) => p0.i20();
}
function LineItem_allowRaiseIssue$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[13];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_allowRaiseIssue$_get_serializer_$ref_rdp1pu() {
  return (p0) => p0.h2j();
}
function LineItem_allowRaiseIssue$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(13);
}
function LineItem_allowRaiseIssue$_get_annotations_$ref_ciww22() {
  return (p0) => p0.bz();
}
var LineItem_allowRaiseIssueClass;
function LineItem_allowRaiseIssue() {
  if (LineItem_allowRaiseIssueClass === VOID) {
    class $ {
      constructor() {
        LineItem_allowRaiseIssue_instance = this;
        var tmp = this;
        tmp.h6o_1 = lazy(LineItem_allowRaiseIssue$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i6o_1 = lazy(LineItem_allowRaiseIssue$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j6o_1 = lazy(LineItem_allowRaiseIssue$annotations$delegate$lambda);
        this.k6o_1 = false;
        this.l6o_1 = 'false';
      }
      i20() {
        var tmp0 = this.h6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_allowRaiseIssue$_get_name_$ref_by02yz(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.r6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      m6o(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.m6o(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_allowRaiseIssue$_get_serializer_$ref_rdp1pu(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_allowRaiseIssue$_get_annotations_$ref_ciww22(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_allowRaiseIssue', VOID, VOID, [SerializableProperty()]);
    LineItem_allowRaiseIssueClass = $;
  }
  return LineItem_allowRaiseIssueClass;
}
var LineItem_allowRaiseIssue_instance;
function LineItem_allowRaiseIssue_getInstance() {
  if (LineItem_allowRaiseIssue_instance === VOID)
    new (LineItem_allowRaiseIssue())();
  return LineItem_allowRaiseIssue_instance;
}
function LineItem_allowFileDispute$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(14);
}
function LineItem_allowFileDispute$_get_name_$ref_vrx2nw() {
  return (p0) => p0.i20();
}
function LineItem_allowFileDispute$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[14];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_allowFileDispute$_get_serializer_$ref_kbyyqz() {
  return (p0) => p0.h2j();
}
function LineItem_allowFileDispute$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(14);
}
function LineItem_allowFileDispute$_get_annotations_$ref_74shyp() {
  return (p0) => p0.bz();
}
var LineItem_allowFileDisputeClass;
function LineItem_allowFileDispute() {
  if (LineItem_allowFileDisputeClass === VOID) {
    class $ {
      constructor() {
        LineItem_allowFileDispute_instance = this;
        var tmp = this;
        tmp.n6o_1 = lazy(LineItem_allowFileDispute$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o6o_1 = lazy(LineItem_allowFileDispute$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p6o_1 = lazy(LineItem_allowFileDispute$annotations$delegate$lambda);
        this.q6o_1 = false;
        this.r6o_1 = 'false';
      }
      i20() {
        var tmp0 = this.n6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_allowFileDispute$_get_name_$ref_vrx2nw(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.s6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      m6o(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.m6o(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.o6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_allowFileDispute$_get_serializer_$ref_kbyyqz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_allowFileDispute$_get_annotations_$ref_74shyp(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_allowFileDispute', VOID, VOID, [SerializableProperty()]);
    LineItem_allowFileDisputeClass = $;
  }
  return LineItem_allowFileDisputeClass;
}
var LineItem_allowFileDispute_instance;
function LineItem_allowFileDispute_getInstance() {
  if (LineItem_allowFileDispute_instance === VOID)
    new (LineItem_allowFileDispute())();
  return LineItem_allowFileDispute_instance;
}
function LineItem_allowLockProject$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(15);
}
function LineItem_allowLockProject$_get_name_$ref_p097hy() {
  return (p0) => p0.i20();
}
function LineItem_allowLockProject$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[15];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_allowLockProject$_get_serializer_$ref_jsge41() {
  return (p0) => p0.h2j();
}
function LineItem_allowLockProject$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(15);
}
function LineItem_allowLockProject$_get_annotations_$ref_9o79sl() {
  return (p0) => p0.bz();
}
var LineItem_allowLockProjectClass;
function LineItem_allowLockProject() {
  if (LineItem_allowLockProjectClass === VOID) {
    class $ {
      constructor() {
        LineItem_allowLockProject_instance = this;
        var tmp = this;
        tmp.s6o_1 = lazy(LineItem_allowLockProject$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t6o_1 = lazy(LineItem_allowLockProject$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u6o_1 = lazy(LineItem_allowLockProject$annotations$delegate$lambda);
        this.v6o_1 = false;
        this.w6o_1 = 'false';
      }
      i20() {
        var tmp0 = this.s6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_allowLockProject$_get_name_$ref_p097hy(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.t6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      m6o(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.m6o(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.t6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_allowLockProject$_get_serializer_$ref_jsge41(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_allowLockProject$_get_annotations_$ref_9o79sl(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_allowLockProject', VOID, VOID, [SerializableProperty()]);
    LineItem_allowLockProjectClass = $;
  }
  return LineItem_allowLockProjectClass;
}
var LineItem_allowLockProject_instance;
function LineItem_allowLockProject_getInstance() {
  if (LineItem_allowLockProject_instance === VOID)
    new (LineItem_allowLockProject())();
  return LineItem_allowLockProject_instance;
}
function LineItem_issue$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(16);
}
function LineItem_issue$_get_name_$ref_msu242() {
  return (p0) => p0.i20();
}
function LineItem_issue$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[16];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_issue$_get_serializer_$ref_3fu6ph() {
  return (p0) => p0.h2j();
}
function LineItem_issue$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(16);
}
function LineItem_issue$_get_annotations_$ref_jbj9i1() {
  return (p0) => p0.bz();
}
var LineItem_issueClass;
function LineItem_issue() {
  if (LineItem_issueClass === VOID) {
    class $ {
      constructor() {
        LineItem_issue_instance = this;
        var tmp = this;
        tmp.x6o_1 = lazy(LineItem_issue$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y6o_1 = lazy(LineItem_issue$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z6o_1 = lazy(LineItem_issue$annotations$delegate$lambda);
        this.a6p_1 = null;
        this.b6p_1 = 'null';
      }
      i20() {
        var tmp0 = this.x6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_issue$_get_name_$ref_msu242(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.u6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      c6p(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.c6p(tmp, (value == null ? true : value instanceof Issue()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_issue$_get_serializer_$ref_3fu6ph(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z6o_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_issue$_get_annotations_$ref_jbj9i1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_issue', VOID, VOID, [SerializableProperty()]);
    LineItem_issueClass = $;
  }
  return LineItem_issueClass;
}
var LineItem_issue_instance;
function LineItem_issue_getInstance() {
  if (LineItem_issue_instance === VOID)
    new (LineItem_issue())();
  return LineItem_issue_instance;
}
function LineItem_credits$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(17);
}
function LineItem_credits$_get_name_$ref_x2vz5b() {
  return (p0) => p0.i20();
}
function LineItem_credits$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[17];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_credits$_get_serializer_$ref_vea7py() {
  return (p0) => p0.h2j();
}
function LineItem_credits$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(17);
}
function LineItem_credits$_get_annotations_$ref_5131sq() {
  return (p0) => p0.bz();
}
var LineItem_creditsClass;
function LineItem_credits() {
  if (LineItem_creditsClass === VOID) {
    class $ {
      constructor() {
        LineItem_credits_instance = this;
        var tmp = this;
        tmp.d6p_1 = lazy(LineItem_credits$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e6p_1 = lazy(LineItem_credits$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f6p_1 = lazy(LineItem_credits$annotations$delegate$lambda);
        this.g6p_1 = emptyList();
        this.h6p_1 = 'emptyList()';
      }
      i20() {
        var tmp0 = this.d6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_credits$_get_name_$ref_x2vz5b(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.v6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      i6p(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.i6p(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.e6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_credits$_get_serializer_$ref_vea7py(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_credits$_get_annotations_$ref_5131sq(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_credits', VOID, VOID, [SerializableProperty()]);
    LineItem_creditsClass = $;
  }
  return LineItem_creditsClass;
}
var LineItem_credits_instance;
function LineItem_credits_getInstance() {
  if (LineItem_credits_instance === VOID)
    new (LineItem_credits())();
  return LineItem_credits_instance;
}
function LineItem_complete$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(18);
}
function LineItem_complete$_get_name_$ref_rbbnz2() {
  return (p0) => p0.i20();
}
function LineItem_complete$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[18];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_complete$_get_serializer_$ref_aqx0sb() {
  return (p0) => p0.h2j();
}
function LineItem_complete$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(18);
}
function LineItem_complete$_get_annotations_$ref_wyadyh() {
  return (p0) => p0.bz();
}
var LineItem_completeClass;
function LineItem_complete() {
  if (LineItem_completeClass === VOID) {
    class $ {
      constructor() {
        LineItem_complete_instance = this;
        var tmp = this;
        tmp.j6p_1 = lazy(LineItem_complete$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k6p_1 = lazy(LineItem_complete$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l6p_1 = lazy(LineItem_complete$annotations$delegate$lambda);
        this.m6p_1 = null;
        this.n6p_1 = 'null';
      }
      i20() {
        var tmp0 = this.j6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_complete$_get_name_$ref_rbbnz2(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.w6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      o6p(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.o6p(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.k6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_complete$_get_serializer_$ref_aqx0sb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_complete$_get_annotations_$ref_wyadyh(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_complete', VOID, VOID, [SerializableProperty()]);
    LineItem_completeClass = $;
  }
  return LineItem_completeClass;
}
var LineItem_complete_instance;
function LineItem_complete_getInstance() {
  if (LineItem_complete_instance === VOID)
    new (LineItem_complete())();
  return LineItem_complete_instance;
}
function LineItem_ledgerItems$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(19);
}
function LineItem_ledgerItems$_get_name_$ref_tp7cs4() {
  return (p0) => p0.i20();
}
function LineItem_ledgerItems$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[19];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_ledgerItems$_get_serializer_$ref_nxdwhf() {
  return (p0) => p0.h2j();
}
function LineItem_ledgerItems$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(19);
}
function LineItem_ledgerItems$_get_annotations_$ref_nhkk7r() {
  return (p0) => p0.bz();
}
var LineItem_ledgerItemsClass;
function LineItem_ledgerItems() {
  if (LineItem_ledgerItemsClass === VOID) {
    class $ {
      constructor() {
        LineItem_ledgerItems_instance = this;
        var tmp = this;
        tmp.p6p_1 = lazy(LineItem_ledgerItems$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q6p_1 = lazy(LineItem_ledgerItems$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r6p_1 = lazy(LineItem_ledgerItems$annotations$delegate$lambda);
        this.s6p_1 = emptySet();
        this.t6p_1 = 'emptySet()';
      }
      i20() {
        var tmp0 = this.p6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_ledgerItems$_get_name_$ref_tp7cs4(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.x6k_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      u6p(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.u6p(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.q6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_ledgerItems$_get_serializer_$ref_nxdwhf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_ledgerItems$_get_annotations_$ref_nhkk7r(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_ledgerItems', VOID, VOID, [SerializableProperty()]);
    LineItem_ledgerItemsClass = $;
  }
  return LineItem_ledgerItemsClass;
}
var LineItem_ledgerItems_instance;
function LineItem_ledgerItems_getInstance() {
  if (LineItem_ledgerItems_instance === VOID)
    new (LineItem_ledgerItems())();
  return LineItem_ledgerItems_instance;
}
function LineItem_contractorDeposits$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(22);
}
function LineItem_contractorDeposits$_get_name_$ref_mzsze7() {
  return (p0) => p0.i20();
}
function LineItem_contractorDeposits$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[22];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_contractorDeposits$_get_serializer_$ref_8q3dw6() {
  return (p0) => p0.h2j();
}
function LineItem_contractorDeposits$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(22);
}
function LineItem_contractorDeposits$_get_annotations_$ref_2g5tba() {
  return (p0) => p0.bz();
}
var LineItem_contractorDepositsClass;
function LineItem_contractorDeposits() {
  if (LineItem_contractorDepositsClass === VOID) {
    class $ {
      constructor() {
        LineItem_contractorDeposits_instance = this;
        var tmp = this;
        tmp.v6p_1 = lazy(LineItem_contractorDeposits$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.w6p_1 = lazy(LineItem_contractorDeposits$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.x6p_1 = lazy(LineItem_contractorDeposits$annotations$delegate$lambda);
        this.y6p_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.z6p_1 = 'MonetaryValue(0L)';
      }
      i20() {
        var tmp0 = this.v6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_contractorDeposits$_get_name_$ref_mzsze7(), null);
        return tmp0.f2();
      }
      m6l(receiver) {
        return receiver.a6l_1;
      }
      k2j(receiver) {
        return new (MonetaryValue())(this.m6l(receiver instanceof LineItem() ? receiver : THROW_CCE()));
      }
      n6l(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.n6l(tmp, value instanceof MonetaryValue() ? value.y5r_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.w6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_contractorDeposits$_get_serializer_$ref_8q3dw6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.x6p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_contractorDeposits$_get_annotations_$ref_2g5tba(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_contractorDeposits', VOID, VOID, [SerializableProperty()]);
    LineItem_contractorDepositsClass = $;
  }
  return LineItem_contractorDepositsClass;
}
var LineItem_contractorDeposits_instance;
function LineItem_contractorDeposits_getInstance() {
  if (LineItem_contractorDeposits_instance === VOID)
    new (LineItem_contractorDeposits())();
  return LineItem_contractorDeposits_instance;
}
function LineItem_readBy$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(23);
}
function LineItem_readBy$_get_name_$ref_1nbxf6() {
  return (p0) => p0.i20();
}
function LineItem_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[23];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_readBy$_get_serializer_$ref_xoxwmf() {
  return (p0) => p0.h2j();
}
function LineItem_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(23);
}
function LineItem_readBy$_get_annotations_$ref_xxx94t() {
  return (p0) => p0.bz();
}
var LineItem_readByClass;
function LineItem_readBy() {
  if (LineItem_readByClass === VOID) {
    class $ {
      constructor() {
        LineItem_readBy_instance = this;
        var tmp = this;
        tmp.a6q_1 = lazy(LineItem_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.b6q_1 = lazy(LineItem_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.c6q_1 = lazy(LineItem_readBy$annotations$delegate$lambda);
        this.d6q_1 = emptySet();
        this.e6q_1 = 'emptySet()';
      }
      i20() {
        var tmp0 = this.a6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_readBy$_get_name_$ref_1nbxf6(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.b6l_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      u6p(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.u6p(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.b6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_readBy$_get_serializer_$ref_xoxwmf(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.c6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_readBy$_get_annotations_$ref_xxx94t(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_readBy', VOID, VOID, [SerializableProperty()]);
    LineItem_readByClass = $;
  }
  return LineItem_readByClass;
}
var LineItem_readBy_instance;
function LineItem_readBy_getInstance() {
  if (LineItem_readBy_instance === VOID)
    new (LineItem_readBy())();
  return LineItem_readBy_instance;
}
function LineItem_lastModifiedBy$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(24);
}
function LineItem_lastModifiedBy$_get_name_$ref_7y9tiz() {
  return (p0) => p0.i20();
}
function LineItem_lastModifiedBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[24];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LineItem_lastModifiedBy$_get_serializer_$ref_t1i3j2() {
  return (p0) => p0.h2j();
}
function LineItem_lastModifiedBy$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(24);
}
function LineItem_lastModifiedBy$_get_annotations_$ref_vtjb6u() {
  return (p0) => p0.bz();
}
var LineItem_lastModifiedByClass;
function LineItem_lastModifiedBy() {
  if (LineItem_lastModifiedByClass === VOID) {
    class $ {
      constructor() {
        LineItem_lastModifiedBy_instance = this;
        var tmp = this;
        tmp.f6q_1 = lazy(LineItem_lastModifiedBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g6q_1 = lazy(LineItem_lastModifiedBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h6q_1 = lazy(LineItem_lastModifiedBy$annotations$delegate$lambda);
        this.i6q_1 = null;
        this.j6q_1 = 'null';
      }
      i20() {
        var tmp0 = this.f6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LineItem_lastModifiedBy$_get_name_$ref_7y9tiz(), null);
        return tmp0.f2();
      }
      d6k(receiver) {
        return receiver.c6l_1;
      }
      k2j(receiver) {
        return this.d6k(receiver instanceof LineItem() ? receiver : THROW_CCE());
      }
      k6m(receiver, value) {
        return receiver.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LineItem() ? receiver : THROW_CCE();
        return this.k6m(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.g6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LineItem_lastModifiedBy$_get_serializer_$ref_t1i3j2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h6q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LineItem_lastModifiedBy$_get_annotations_$ref_vtjb6u(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LineItem_lastModifiedBy', VOID, VOID, [SerializableProperty()]);
    LineItem_lastModifiedByClass = $;
  }
  return LineItem_lastModifiedByClass;
}
var LineItem_lastModifiedBy_instance;
function LineItem_lastModifiedBy_getInstance() {
  if (LineItem_lastModifiedBy_instance === VOID)
    new (LineItem_lastModifiedBy())();
  return LineItem_lastModifiedBy_instance;
}
//region block: exports
export {
  get__id as get__id219tqyp0nxml1,
  get_cancelled as get_cancelled2dthnu39zs2ql,
  get_created as get_created1jpxpz5eqbezu,
  get_order as get_order2yr4ophs8mhb3,
  prepareLineItemFields as prepareLineItemFieldspd7i192xwmqb,
  get_project as get_project15zbqkhtwq5i6,
  get_scopeSet as get_scopeSet9qq32a9d0llm,
  get_started as get_started14uxkm9fjiknx,
  get_state as get_state1s5baftgdwrse,
  LineItem_description_getInstance as LineItem_description_getInstancevytol0at3mie,
  LineItem_files_getInstance as LineItem_files_getInstancel1rkwtgpml47,
  LineItem_name_getInstance as LineItem_name_getInstance2tmkd7sdgzzsk,
  LineItem_order_getInstance as LineItem_order_getInstancentdi0e9dyong,
  LineItem_originalPrice_getInstance as LineItem_originalPrice_getInstance21mba1sq9qfcr,
};
//endregion

//# sourceMappingURL=LineItemFields.mjs.map
